import { render, staticRenderFns } from "./client-profiles-filter-dropdown.vue?vue&type=template&id=206ecef7"
import script from "./client-profiles-filter-dropdown.vue?vue&type=script&lang=js"
export * from "./client-profiles-filter-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports